<template>
  <div class="animated fadeIn">
      <div class="card">
        <div class="card-header">
        <strong>Update</strong> Password</div>
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12 col-md-8">
              <form class="form-horizontal" action="" method="post">
                <div class="form-group row">
                  <label class="col-md-4 col-form-label" for="hf-email">Email</label>
                  <div class="col-md-8">
                    <input class="form-control" id="email" type="email" readonly name="email" :value="currentUserName">
                  </div>
                </div>
                <div class="form-group row" :class="{ 'form-group--error': $v.oldPassword.$error }">
                  <label class="col-md-4 col-form-label" for="old-password">Old Password</label>
                  <div class="col-md-8">
                    <input class="form-control" @input="$v.oldPassword.$touch()" v-model.trim="oldPassword" type="password" placeholder="Enter Old Password..">
                  </div>
                </div>
                <div class="form-group row" :class="{ 'form-group--error': $v.password.$error }">
                  <label class="col-md-4 col-form-label" for="new-password">New Password</label>
                  <div class="col-md-8">
                    <input class="form-control" @input="$v.password.$touch()" v-model.trim="password" type="password" placeholder="Enter New Password..">
                    <em style="color:#fa9c9c" v-if="!$v.password.minLength">Password must have at least {{ $v.password.$params.minLength.min }} letters.</em>
                    <em style="color:#fa9c9c" v-if="!$v.password.required">Password is required.</em>
                  </div>
                </div>
                <div class="form-group row" :class="{ 'form-group--error': $v.repeatPassword.$error }">
                  <label class="col-md-4 col-form-label" for="repeat-password">Repeat Password</label>
                  <div class="col-md-8">
                    <input class="form-control" @input="$v.repeatPassword.$touch()" v-model.trim="repeatPassword" type="password" placeholder="Enter Repeat Password..">
                    <em style="color:#fa9c9c" v-if="!$v.repeatPassword.sameAsPassword">Passwords must be identical.</em>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-sm btn-primary" @click.stop.prevent="handleSubmit" type="submit" >
          <i class="fa fa-dot-circle-o"></i> Submit</button>
        </div>
      </div>
</div>
</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'changePassword',
  data () {
    return {
      oldPassword: '',
      password: '',
      repeatPassword: ''
    }
  },
  computed: {
    currentUserName: function () {
      return localStorage.getItem('user_name')
    }
  },
  methods: {
    handleSubmit () {
      if (this.$v.$invalid) {
        this.$swal({
          title: 'You have not set your Shipper Account',
          text: 'Please Create Shipper Account First!',
          icon: 'warning',
          animation: false,
          customClass: 'animated tada'
        })
        return
      }
      // change user password
      this.axios.post('/user/update-password', {
        old_password: this.oldPassword,
        password: this.password
      }).then(() => {
        this.$router.push('/dashboard')
      }).catch(error => {
        this.$swal({
          title: 'Failed message',
          text: error.data.message,
          icon: 'warning',
          animation: false,
          customClass: 'animated tada'
        })
      })
    }
  },
  validations: {
    oldPassword: {
      required
    },
    password: {
      required,
      minLength: minLength(6)
    },
    repeatPassword: {
      sameAsPassword: sameAs('password')
    }
  }
}
</script>
